namespace GeniuzPOS.Purchase {
    export class PoCNRTVDtColumns {
        static columnsKey = 'Purchase.PoCNRTVDt';
    }
}
